export default "__VITE_ASSET__C6ZWhDU9__"